<template>
  <div class="tva-lang-switcher">
    <router-link
      :class="[$ml.current === lang ? 'selected' : '']"
      v-for="lang in $ml.list"
      :key="lang"
      :to="{ params: { lang } }"
      v-text="lang"
    />
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.tva-lang-switcher {
  display: flex;
  margin: 0 5em;
  &-text {
    margin-right: 10px;
  }
  a {
    color: inherit;
    text-decoration: none;
    &.selected {
      text-decoration: underline;
    }
    &:first-of-type {
      border-right: solid 1px black;
      padding-right: 10px;
      margin-right: 10px;
    }
  }
}
</style>
